/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='employeeSupplyUsage.module.ts' />
///<reference path="../../components/short-cuts/models/short-cuts-state-manager.controller.ts"/>


module Meevo.Plugins.EmployeeSupplyUsage {

    class GroupedEmployeeSupplyUsageController {
        static $inject = ['meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            "meevo.components.common.InventoryRoundingService",
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.busy.BusyService',
            '$translate',
            "$filter",
            '$timeout',
            '$q',
            'groupedData'];

        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $filter: angular.IFilterService,
            protected $timeout: angular.ITimeoutService,
            private $q: angular.IQService,
            protected groupedData: any) {

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

        }

        public getVariantNames(item) {
            var variantName = (item.variantDisplayName && item.variantDisplayName != "") ? (" - " + String(item.variantDisplayName).replace("|", " ")) : "";
            return variantName;
        }

        public exportToCsv() {
            var filename = "employeeSupplyUsage" + (new Date()).valueOf() + ".csv";
            var csvFile = this.$translate.instant("LABEL_CATEGORY") + "," + this.$translate.instant("LABEL_PRODUCT") + "," + this.$translate.instant("LABEL_WHOLESALE_COST") + "," + this.$translate.instant("LABEL_QUANTITY_USED") + "," + this.$translate.instant("LABEL_LINE_TOTAL") + '\r\n';

            for (var key in this.groupedData.groups) {
                var group: any = this.groupedData.groups[key];
                csvFile += "\"" + group.displayName + "\",,,,\r\n";

                group.items.forEach((item: any) => {
                    let quantityStr = String((item.enableProductUsageTracking && item.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount)
                        ? item.quantity
                        : item.quantity.toFixed());
                    csvFile += ",\"" + item.sku + " : " + item.productDisplayName + this.getVariantNames(item) + " : " + item.barCode + "\"," + item.wholesale + "," + quantityStr + "," + item.totalWholesale + "\r\n";
                });

                let subTotalQuantityStr = String((group.hasPartialUsage) ? group.subTotalQuantity : group.subTotalQuantity.toFixed());
                csvFile += ",\"" + this.$translate.instant("LABEL_SUB_SPACE_TOTAL") + ": " + group.displayName + "\",," + subTotalQuantityStr + "," + group.subTotalWholesale + "\r\n";
            }
            let totalQuantityStr = String((this.groupedData.hasPartialUsageInAGroup) ? this.groupedData.totalQuantity : this.groupedData.totalQuantity.toFixed());
            csvFile += ",," + this.$translate.instant("LABEL_TOTAL") + "," + totalQuantityStr + "," + this.groupedData.totalWholesale + "\r\n";

            var blob = new Blob([csvFile], { type: 'text/csv;;charset=utf-8;' });

            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            }
            else {
                var link = document.createElement("a");
                if (link["download"] !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }

        displayCalculatedQuantity(item: any): string{
            return this.$filter("number")(this.roundingService.addNormalizedNumbers(item.quantity, this.roundingService.divideNormalizedNumbers(item.quantityUnits, item.unitOfMeasureQuantity, this.decimalPrecision), this.decimalPrecision), item.enableProductUsageTracking ? this.decimalPrecision : 0);
        }

        isProductUsageEnabled(variant: any): boolean {
            return this.tenantEnableProductUsageTracking && variant.enableProductUsageTracking && variant.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount;
        }
    }

angular.module('meevo.plugins.employeeSupplyUsage')
    .controller('meevo.plugins.employeeSupplyUsage.GroupedEmployeeSupplyUsageController', GroupedEmployeeSupplyUsageController);
}
